export default __webpack_public_path__ + "static/media/French-Linen.2925ccb3.jpg";